import script from "./index-web.vue?vue&type=script&lang=ts&setup=true"
export * from "./index-web.vue?vue&type=script&lang=ts&setup=true"

import "./index-web.vue?vue&type=style&index=0&id=bdfa5e18&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bdfa5e18"]])

export default __exports__